import { Check } from "lucide-react";
import { CONVERSATION_SORT_OPTIONS, useConversationHistoryFilters } from "@noa/ui";
import type { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { ArrowUpDown } from "lucide-react";
import { useConversationsList } from "@noa/api-client";
import { Button, Dropdown, type MenuProps } from "~/components/ui";
import { ConversationHistoryListContent } from "./conversation-history-list-content";
import { ConversationHistoryListHeader } from "./conversation-history-list-header";
import { ConversationHistorySearchInput } from "./conversation-history-search-input";

export const ConversationHistoryList: FunctionComponent = () => {
  const { t } = useTranslation();
  const { showDeleted, setShowDeleted, search, setSearch, debouncedSearch, sort, setSort, listParams } =
    useConversationHistoryFilters();
  const { conversations } = useConversationsList(listParams);

  const sortMenuItems: MenuProps["items"] = CONVERSATION_SORT_OPTIONS.map(({ key, labelKey }) => ({
    key,
    disabled: sort === key,
    onClick: () => setSort(key),
    label: (
      <div className="flex items-center gap-2">
        {t(labelKey)}
        {sort === key && <Check size={10} />}
      </div>
    ),
  }));

  return (
    <div className="flex h-full flex-col">
      <div className="flex flex-col border-b border-noa p-5">
        <ConversationHistoryListHeader showDeleted={showDeleted} setShowDeleted={setShowDeleted} />
        {!showDeleted && (
          <div className="flex items-center gap-2">
            <Dropdown menu={{ items: sortMenuItems }} placement="bottomLeft" trigger={["click"]}>
              <Button
                variant="text"
                size="small"
                icon={<ArrowUpDown size={14} color={sort !== "new-old" ? "var(--info)" : "var(--text-faint)"} />}
                title={t("conversation:sort.label")}
              />
            </Dropdown>
            <ConversationHistorySearchInput search={search} setSearch={setSearch} />
          </div>
        )}
      </div>

      <ConversationHistoryListContent conversations={conversations} deleted={showDeleted} search={debouncedSearch} />
    </div>
  );
};
